import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  NoteBuilder,
  NotificationService,
  RestService,
  ServerSettingsService,
} from '@infodata-group/inf-commons';
import { PreferencesSettingsKeyEnum } from '../enum/preferences-settings-key.enum';
import { SETTINGS_DEFAULT_VALUES } from '../engine/app.constants';

@Injectable({
  providedIn: 'root',
})
export class CustomServerSettingsService extends ServerSettingsService {
  private readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);

  constructor(restService: RestService) {
    super(restService);
    this.obs.subscribe({
      next: (settings) => {
        this.setDefaultSettings(settings);
      },
    });
  }

  private setDefaultSettings(settings: unknown) {
    Object.values(PreferencesSettingsKeyEnum).forEach((key) => {
      if (
        settings[key] === undefined &&
        SETTINGS_DEFAULT_VALUES[key] !== undefined
      ) {
        settings[key] = SETTINGS_DEFAULT_VALUES[key];
      }
    });
  }

  public override reset() {
    const presets = this.getSetting('presets');
    this.settings = {};
    this.setDefaultSettings(this.settings);
    this.addSetting('presets', presets);
    this.save();
  }

  public override save() {
    if (!this.settings) {
      this.settings = {};
    }
    if (!this.tm) {
      this.tm = setTimeout(() => {
        const uri = `${this.rest.config.settingsApi}/${this.getSettingsKey()}`;
        if (Object.keys(this.settings).length !== 0) {
          this.rest
            .put(uri, this.settings, { showLoading: false })
            .subscribe(() => {
              localStorage.setItem(
                this.getSettingsKey(),
                JSON.stringify(this.settings),
              );
              this.displayNotification();
              this.tm = null;
            });
        } else {
          this.tm = null;
        }
      }, 5000);
    }
  }

  private displayNotification(): void {
    if (!this.router.url.includes('preferences')) {
      return;
    }
    this.notificationService.addNotification(
      new NoteBuilder(
        'i18n.common.save-preferences-title',
        'save',
        'i18n.common.save-preferences-text',
      )
        .setInfoNote()
        .build(),
    );
  }
}
